// CP-4 — BustNotificationBanner.
//
// Shows the most recent unacknowledged bust notification (Slice α
// writes it on every bust). User dismisses via acknowledge RPC.
// Wording carries the honest capital_after — the user always knows
// what their bank looks like post-bust.

import type { ScBustNotification } from "../../singles/useBustNotifications.ts";

export interface BustNotificationBannerProps {
  notification: ScBustNotification;
  onDismiss: (id: string) => void;
}

export function BustNotificationBanner({
  notification,
  onDismiss,
}: BustNotificationBannerProps): JSX.Element {
  return (
    <div
      className={`sc-bust-banner sc-bust-banner--${notification.stake_source}`}
      role="alert"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 14,
        background: "var(--fp-lost-soft)",
        border: "1px solid var(--fp-lost)",
        borderRadius: 10,
        padding: 14,
      }}
    >
      <div
        className="sc-bust-banner-body"
        style={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 5 }}
      >
        <span
          className="sc-bust-banner-eyebrow"
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: 10.5,
            fontWeight: 600,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "var(--fp-lost)",
          }}
        >
          Chain busted · G{notification.bust_game}
        </span>
        <p
          className="sc-bust-banner-msg"
          style={{
            margin: 0,
            fontSize: 13,
            lineHeight: 1.45,
            color: "var(--text)",
          }}
        >
          {notification.message}
        </p>
      </div>
      <button
        type="button"
        className="btn btn-sm"
        onClick={() => onDismiss(notification.id)}
        aria-label="Acknowledge bust notification"
        style={{
          flexShrink: 0,
          padding: "7px 14px",
          borderRadius: 4,
          border: "1px solid var(--fp-lost)",
          background: "transparent",
          color: "var(--fp-lost)",
          fontFamily: "var(--font-mono)",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.10em",
          textTransform: "uppercase",
          cursor: "pointer",
        }}
      >
        Got it
      </button>
    </div>
  );
}
